// eContactType and eContactEnvironment for use in custom contact duplication error message

export enum eContactType {
  Client = 'CLIENT',
  Internal = 'INTERNAL',
  Lender = 'LENDER',
  ThirdParty = 'THIRD_PARTY',
}

export enum eContactEnvironment {
  Client = 'CLIENT',
  Lender = 'LENDER',
  Order = 'ORDER',
}

export const prettyContactTypeFunction: Record<eContactType, string> = {
  [eContactType.Client]: 'A client',
  [eContactType.Internal]: 'An internal',
  [eContactType.Lender]: 'A lender',
  [eContactType.ThirdParty]: 'A third party',
};

export const prettyContactEnvironmentFunction: Record<eContactEnvironment, string> = {
  [eContactEnvironment.Client]: 'client',
  [eContactEnvironment.Lender]: 'lender',
  [eContactEnvironment.Order]: 'order',
};

export const getContactDuplicationMessage = (contactType: eContactType, environment: eContactEnvironment) =>
  `${prettyContactTypeFunction[contactType]} contact with that name has already been added to this ${prettyContactEnvironmentFunction[environment]}`;
